import useZones from './useZones';

export default useZones;
